import React from "react";
import Badge from "@dtci/spellbook/Badge";
import Icon from "@dtci/spellbook/Icon";
import { getSeverityColor, getSeverityIcon } from "ppt/utilities";

export const PPTSeverityBadge = React.memo(({ severity }) => {
  return (
    <Badge light shape="circle" color={getSeverityColor(severity)}>
      <Icon
        iconType="fa"
        faPackage="fal"
        iconName={getSeverityIcon(severity)}
        title={severity}
      />
    </Badge>
  );
});
